import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalQuizComponent } from '../modal-quiz/modal-quiz.component';
import pdfMake from 'pdfmake/build/pdfmake';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import pdfFonts from 'src/assets/custom-fonts.js';
import { LogoChula } from 'src/app/shared/logo-chula-encode'
import { ELearningService } from '../../e-learning.service';

@Component({
  selector: 'app-modal-certificate',
  templateUrl: './modal-certificate.component.html',
  styleUrls: ['./modal-certificate.component.scss']
})
export class ModalCertificateComponent implements OnInit {
  certificateForm: FormGroup;
  checkUsername: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCertificateComponent>,
    private fb: FormBuilder,
    private elearningService: ELearningService,
  ) { }

  ngOnInit(): void {
    // // console.log(this.data);
    this.createForm();
  }

  closeModal() {
    const response = {
      status: false,
      value: {}
    }

    this.dialogRef.close(response);
  }

  createForm() {
    // // console.log(this.checkUsername);
    if (!this.checkUsername) {
      this.certificateForm = this.fb.group({
        name: ['', Validators.required],
        surname: ['', Validators.required]
      })
    } else {
      this.certificateForm = this.fb.group({
        name: [this.data.USERNAME, Validators.required],
      })
    }

    // // console.log(this.certificateForm);
  }

  createCertificate(form) {
    let today = new Date();
    // // console.log(form);
    let cer_data = {
      name: form.surname ? `${form.name} ${form.surname}` : form.name,
      courseName: this.data.COURSE_NAME,
      from_date: this.data.LEARN_FROM,
      to_date: this.data.LEARN_TO,
      today: new DatePipe().transform(today.toString(), 'full'),
      professor1: 'ผู้ช่วยศาสตราจารย์ ดร.พรรณระพี สุทธิวรรณ',
      position1: 'คณบดีคณะจิตวิทยา',
      professor2: 'ศาสตราจารย์ ดร.บัณฑิต เอื้ออาภรณ์',
      position2: 'อธิการบดี',
    }
    this.openCertificate(cer_data);
  }

  openCertificate(cer_data) {
    // // console.log(cer_data);
    pdfMake.vfs = pdfFonts.pdfMake.vfs

    pdfMake.fonts = {
      THCharmOfAU: {
        normal: 'THCharmOfAU.ttf',
        bold: 'THCharmOfAU.ttf',
        italics: 'THCharmOfAU.ttf',
        bolditalics: 'THCharmOfAU.ttf',
      }
    }

    var documentDefinition = {
      pageOrientation: 'landscape',
      pageMargins: [ 30, 40, 30, 30 ],
      content: [
        // Header
        {
          columns: [
            {
              image: LogoChula,
              width: 60,
              style: 'logoTitle'
            },
          ],
        },
        {
          columns: [
            {
              text: 'คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย',
              width: '*',
              style: 'header'
            }
          ],
        },
        {
          columns: [
            {
              text: 'ขอมอบวุฒิบัตรฉบับนี้ไว้เพื่อแสดงว่า',
              width: '*',
              style: 'subHeader'
            }
          ],
        },
        {
          columns: [
            {
              text: `คุณ ${cer_data.name}`,
              width: '*',
              style: 'username'
            }
          ],
        },
        {
          columns: [
            {
              text: `ได้เข้ารับการอบรมตามโครงการ "${cer_data.courseName}"`,
              width: '*',
              style: 'courseName'
            }
          ],
        },
        {
          columns: [
            {
              text: `ระหว่างวันที่ ${new DatePipe().transform(cer_data.from_date.toString(), 'full')} - ${new DatePipe().transform(cer_data.to_date.toString(), 'full')}`,
              width: '*',
              style: 'courseName'
            }
          ],
        },
        {
          columns: [
            {
              text: `และมีสัมฤทธิผลตามเกณฑ์ของหลักสูตร`,
              width: '*',
              style: 'courseName'
            }
          ],
        },
        {
          columns: [
            {
              text: `ให้ไว้ ณ วันที่ ${cer_data.today}`,
              width: '*',
              style: 'courseName'
            }
          ],
        },
        {
          columns: [
            [
              {
                text: `(${cer_data.professor1})`,
                width: 400,
                style: 'professor1'
              },
              {
                text: `${cer_data.position1}`,
                width: 400,
                style: 'position1'
              },
            ],
            [
              {
                text: `(${cer_data.professor2})`,
                width: 400,
                style: 'professor2'
              },
              {
                text: `${cer_data.position2}`,
                width: 400,
                style: 'position2'
              },
            ],
          ],
        },
      ],
      styles: {
        logoTitle: {
          margin: [365, 0, 0, 0],
          // alignment: 'center',
        },
        header: {
          fontSize: 40,
          alignment: 'center',
        },
        subHeader: {
          fontSize: 22,
          margin: [0, 35, 0, 0],
          alignment: 'center',
        },
        username: {
          fontSize: 30,
          margin: [0, 26, 0, 26],
          color: '#B08D00',
          alignment: 'center',
        },
        courseName: {
          fontSize: 22,
          margin: [0, -4, 0, 0],
          alignment: 'center',
        },
        professor1: {
          fontSize: 20,
          margin: [-40, 53, 0, 0],
          alignment: 'center',
        },
        professor2: {
          fontSize: 20,
          margin: [0, 53, -40, 0],
          alignment: 'center',
        },
        position1: {
          fontSize: 20,
          margin: [-40, -6, 0, 0],
          alignment: 'center',
        },
        position2: {
          fontSize: 20,
          margin: [0, -6, -40, 0],
          alignment: 'center',
        },
      },
      defaultStyle: {
        columnGap: 50,
        font: 'THCharmOfAU'
      },
    };

    // pdfMake.createPdf(documentDefinition).open();
    var pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getBase64((base64) => {
      // // console.log(base64);
      let body = {
          COURSE_ID: this.data.COURSE_ID,
          base64str: base64,
        };

        const response = {
          status: true,
          body: body
        }
        this.dialogRef.close(response);
    });

  }

}
